import {Injectable} from "@angular/core";
import {BehaviorSubject, map, Observable, tap} from "rxjs";
import {HttpClient, HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {LoaderService} from "./loader.service";
import {
  ActionResult, EventItem,
  WspayConfirmation,
  WspayForm,
  WspayFormRequest,
  WspayResult
} from "@model";
import {EnvironmentService} from "./environment.service";

export const WSPAY_RESULT_URL: string = "/api/public/payment/wspay/result";

/// https://docs.wspay.info/wspayform
@Injectable({ providedIn:'root' })
export class WsPayService {

  private static _currentWspayConfirmation: BehaviorSubject<WspayConfirmation | undefined> = new BehaviorSubject<WspayConfirmation | undefined>(undefined);

  get currentWspayConfirmation(): BehaviorSubject<WspayConfirmation | undefined> {
    return WsPayService._currentWspayConfirmation;
  }

  constructor(private loaderService: LoaderService, private http: HttpClient, private environmentService:EnvironmentService) {
  }

  fetchWsPayForm(wsFormRequest: WspayFormRequest, onSuccess: (redirectUrl: string) => void, onError: () => void) {
    this.loaderService.startLoading();
    this.http.post<ActionResult<WspayForm>>(this.environmentService.getApiUrl() + "/api/public/payment/wspay/form", wsFormRequest)
      .pipe((
        tap(() => this.loaderService.dismissLoading())))
      .subscribe((response: ActionResult<WspayForm>) => {
        onSuccess(response.result!.PaymentFormUrl!);
      }, (error: any) => {
      });
  }

  updateWsPayResult(wsPayResult: WspayResult, onError: () => void) {
    this.loaderService.startLoading();
    this.http.post<ActionResult<WspayConfirmation>>(this.environmentService.getApiUrl() + WSPAY_RESULT_URL, wsPayResult)
      .pipe((
        tap(() => this.loaderService.dismissLoading())))
      .subscribe((response: ActionResult<WspayConfirmation>) => {
        if (response.result) {
          this.currentWspayConfirmation.next(response.result);
        }
      }, (error: any) => {
        if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized) {
          onError();
        }
      });
  }

  fetchWsPayResult(wsPayResult: WspayResult): Observable<WspayConfirmation | null> {
    this.loaderService.startLoading();
    return this.http.post<ActionResult<WspayConfirmation>>(this.environmentService.getApiUrl() + WSPAY_RESULT_URL, wsPayResult).pipe(tap(() => {
        this.loaderService.dismissLoading()
    }),map((actionResult: ActionResult<WspayConfirmation>) => {
          if (actionResult && actionResult.result) {
            let event: EventItem = new EventItem();
            event.name = actionResult.result.eventName;
            event.nameEng = actionResult.result.eventNameEng;
            event.nameIta = actionResult.result.eventNameIta;
            event.nameSlo = actionResult.result.eventNameSlo;
            event.defaultLanguage = actionResult.result.eventDefaultLang;
            event.start = actionResult.result.eventStart;
            actionResult.result.event = event;
            return actionResult.result;
          } else {
            return null;
          }
        })
      );
  }

  emptyCurrentWspayConfirmation() {
    this.currentWspayConfirmation.next(undefined);
  }
}
